export enum DonorEvalQuery {
    ToDo = 0,
    Paid = 1
}